import apiClient from './client';
import type {
  SkillGapResult,
  TenderPersonaResult,
  PersonaMatchResult,
  EmployeePersonaGapResult,
} from '../types';

export async function fetchSkillGaps(): Promise<SkillGapResult> {
  const { data } = await apiClient.get<SkillGapResult>('/analytics/skill-gaps');
  return data;
}

export async function fetchTenderPersonas(
  tenderId: string,
): Promise<TenderPersonaResult> {
  const { data } = await apiClient.get<TenderPersonaResult>(
    `/analytics/tenders/${tenderId}/personas`,
  );
  return data;
}

export async function fetchPersonaMatches(): Promise<PersonaMatchResult[]> {
  const { data } = await apiClient.get<PersonaMatchResult[]>(
    '/analytics/persona-matches',
  );
  return data;
}

export async function fetchPersonaMatchById(
  personaId: string,
): Promise<PersonaMatchResult> {
  const { data } = await apiClient.get<PersonaMatchResult>(
    `/analytics/persona-matches/${personaId}`,
  );
  return data;
}

export async function fetchEmployeePersonaGaps(
  employeeId: string,
): Promise<EmployeePersonaGapResult> {
  const { data } = await apiClient.get<EmployeePersonaGapResult>(
    `/analytics/employees/${employeeId}/persona-gaps`,
  );
  return data;
}
